/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { CarrierServicePair } from "./CarrierServicePair";
import {
  CarrierServicePairFromJSON,
  CarrierServicePairFromJSONTyped,
  CarrierServicePairToJSON,
  CarrierServicePairToJSONTyped,
} from "./CarrierServicePair";
import type { StateOfGoodsEnum } from "./StateOfGoodsEnum";
import {
  StateOfGoodsEnumFromJSON,
  StateOfGoodsEnumFromJSONTyped,
  StateOfGoodsEnumToJSON,
  StateOfGoodsEnumToJSONTyped,
} from "./StateOfGoodsEnum";
import type { LineItem } from "./LineItem";
import {
  LineItemFromJSON,
  LineItemFromJSONTyped,
  LineItemToJSON,
  LineItemToJSONTyped,
} from "./LineItem";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";

/**
 *
 * @export
 * @interface RequestAdditionalQuotesBody
 */
export interface RequestAdditionalQuotesBody {
  /**
   *
   * @type {string}
   * @memberof RequestAdditionalQuotesBody
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof RequestAdditionalQuotesBody
   */
  pickupDate: string;
  /**
   *
   * @type {string}
   * @memberof RequestAdditionalQuotesBody
   */
  quoteGroupName: string;
  /**
   *
   * @type {Location}
   * @memberof RequestAdditionalQuotesBody
   */
  pickupLocation: Location;
  /**
   *
   * @type {Location}
   * @memberof RequestAdditionalQuotesBody
   */
  deliveryLocation: Location;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof RequestAdditionalQuotesBody
   */
  lineItems: Array<LineItem>;
  /**
   *
   * @type {boolean}
   * @memberof RequestAdditionalQuotesBody
   */
  allCarriers: boolean;
  /**
   *
   * @type {Array<CarrierServicePair>}
   * @memberof RequestAdditionalQuotesBody
   */
  selectedCarriers: Array<CarrierServicePair>;
  /**
   *
   * @type {boolean}
   * @memberof RequestAdditionalQuotesBody
   */
  disableStandardLimits: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RequestAdditionalQuotesBody
   */
  addInsuranceToShipment: boolean;
  /**
   *
   * @type {number}
   * @memberof RequestAdditionalQuotesBody
   */
  insuranceAmount: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof RequestAdditionalQuotesBody
   */
  insuranceCurrency: CurrencyCode;
  /**
   *
   * @type {StateOfGoodsEnum}
   * @memberof RequestAdditionalQuotesBody
   */
  stateOfGoods?: StateOfGoodsEnum | null;
}

/**
 * Check if a given object implements the RequestAdditionalQuotesBody interface.
 */
export function instanceOfRequestAdditionalQuotesBody(
  value: object,
): value is RequestAdditionalQuotesBody {
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("pickupDate" in value) || value["pickupDate"] === undefined)
    return false;
  if (!("quoteGroupName" in value) || value["quoteGroupName"] === undefined)
    return false;
  if (!("pickupLocation" in value) || value["pickupLocation"] === undefined)
    return false;
  if (!("deliveryLocation" in value) || value["deliveryLocation"] === undefined)
    return false;
  if (!("lineItems" in value) || value["lineItems"] === undefined) return false;
  if (!("allCarriers" in value) || value["allCarriers"] === undefined)
    return false;
  if (!("selectedCarriers" in value) || value["selectedCarriers"] === undefined)
    return false;
  if (
    !("disableStandardLimits" in value) ||
    value["disableStandardLimits"] === undefined
  )
    return false;
  if (
    !("addInsuranceToShipment" in value) ||
    value["addInsuranceToShipment"] === undefined
  )
    return false;
  if (!("insuranceAmount" in value) || value["insuranceAmount"] === undefined)
    return false;
  if (
    !("insuranceCurrency" in value) ||
    value["insuranceCurrency"] === undefined
  )
    return false;
  return true;
}

export function RequestAdditionalQuotesBodyFromJSON(
  json: any,
): RequestAdditionalQuotesBody {
  return RequestAdditionalQuotesBodyFromJSONTyped(json, false);
}

export function RequestAdditionalQuotesBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestAdditionalQuotesBody {
  if (json == null) {
    return json;
  }
  return {
    shipmentId: json["shipmentId"],
    pickupDate: json["pickupDate"],
    quoteGroupName: json["quoteGroupName"],
    pickupLocation: LocationFromJSON(json["pickupLocation"]),
    deliveryLocation: LocationFromJSON(json["deliveryLocation"]),
    lineItems: (json["lineItems"] as Array<any>).map(LineItemFromJSON),
    allCarriers: json["allCarriers"],
    selectedCarriers: (json["selectedCarriers"] as Array<any>).map(
      CarrierServicePairFromJSON,
    ),
    disableStandardLimits: json["disableStandardLimits"],
    addInsuranceToShipment: json["addInsuranceToShipment"],
    insuranceAmount: json["insuranceAmount"],
    insuranceCurrency: CurrencyCodeFromJSON(json["insuranceCurrency"]),
    stateOfGoods:
      json["stateOfGoods"] == null
        ? undefined
        : StateOfGoodsEnumFromJSON(json["stateOfGoods"]),
  };
}

export function RequestAdditionalQuotesBodyToJSON(
  json: any,
): RequestAdditionalQuotesBody {
  return RequestAdditionalQuotesBodyToJSONTyped(json, false);
}

export function RequestAdditionalQuotesBodyToJSONTyped(
  value?: RequestAdditionalQuotesBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentId: value["shipmentId"],
    pickupDate: value["pickupDate"],
    quoteGroupName: value["quoteGroupName"],
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
    lineItems: (value["lineItems"] as Array<any>).map(LineItemToJSON),
    allCarriers: value["allCarriers"],
    selectedCarriers: (value["selectedCarriers"] as Array<any>).map(
      CarrierServicePairToJSON,
    ),
    disableStandardLimits: value["disableStandardLimits"],
    addInsuranceToShipment: value["addInsuranceToShipment"],
    insuranceAmount: value["insuranceAmount"],
    insuranceCurrency: CurrencyCodeToJSON(value["insuranceCurrency"]),
    stateOfGoods: StateOfGoodsEnumToJSON(value["stateOfGoods"]),
  };
}
